import { miniApps as en_miniApps } from "../en/mini-apps";

/** mini-apps — ES slice (114 keys). */
export const miniApps: Record<keyof typeof en_miniApps, string> = {
  miniapps_close_button: "Cerrar",
  miniapps_close_accessibility_label: "Cerrar mini app",
  miniapps_error_load_failed: "No se pudo cargar la mini app",
  miniapps_error_title: "Error",
  miniapps_success_title: "Listo",
  miniapps_cancel_button: "Cancelar",
  miniapps_delete_button: "Eliminar",
  miniapps_try_again_button: "Reintentar",
  miniapps_go_back_button: "Volver",
  miniapps_loading: "Cargando...",
  miniapps_demo_title: "Mini app de demo",
  miniapps_demo_description:
    "Prueba todas las funciones del bridge: info de usuario, almacenamiento, llamadas a la API, toasts, alertas y más.",
  miniapps_demo_open_button: "Abrir demo",
  miniapps_demo_open_full_button: "Abrir mini app de demo",
  miniapps_demo_error_prefix: "Error: {error}",
  miniapps_demo_result_success: "Último resultado: correcto",
  miniapps_demo_result_failed: "Último resultado: fallido",
  miniapps_demo_result_with_data: "Último resultado: {status} - {data}",
  miniapps_permission_request_title: "Solicitud de permiso",
  miniapps_permission_deny_button: "Denegar",
  miniapps_permission_allow_button: "Permitir",
  miniapps_permission_grant_fallback: "Conceder el permiso {permission}",
  miniapps_permission_user_read_title: "Leer perfil",
  miniapps_permission_user_read_description:
    "Acceder a la información de tu perfil, incluidos nombre y foto",
  miniapps_permission_user_write_title: "Modificar perfil",
  miniapps_permission_user_write_description:
    "Realizar cambios en la información de tu perfil",
  miniapps_permission_api_read_title: "Leer datos",
  miniapps_permission_api_read_description:
    "Acceder a los datos de la plataforma Linqx",
  miniapps_permission_api_write_title: "Escribir datos",
  miniapps_permission_api_write_description:
    "Crear o modificar datos en la plataforma Linqx",
  miniapps_permission_camera_title: "Cámara",
  miniapps_permission_camera_description:
    "Tomar fotos o grabar videos con tu cámara",
  miniapps_permission_files_title: "Archivos",
  miniapps_permission_files_description:
    "Acceder a los archivos de tu dispositivo",
  miniapps_permission_notifications_title: "Notificaciones",
  miniapps_permission_notifications_description: "Enviarte notificaciones push",
  miniapps_permission_location_title: "Ubicación",
  miniapps_permission_location_description:
    "Acceder a la ubicación de tu dispositivo",
  miniapps_permission_storage_title: "Almacenamiento",
  miniapps_permission_storage_description:
    "Guardar datos localmente en tu dispositivo",
  miniapps_permission_haptics_title: "Vibración",
  miniapps_permission_haptics_description: "Ofrecer respuesta háptica",
  miniapps_permission_contacts_title: "Contactos",
  miniapps_permission_contacts_description: "Acceder a tus contactos",
  miniapps_permission_default_label: "Permiso predeterminado",
  miniapps_permission_optional_label: "Permiso opcional",
  miniapps_list_title: "Mini apps",
  miniapps_list_loading: "Cargando mini apps...",
  miniapps_list_error_title: "No se pudieron cargar las mini apps",
  miniapps_list_create_button: "Crear",
  miniapps_list_empty_title: "Aún no hay mini apps",
  miniapps_list_empty_description:
    "Crea tu primera mini app o espera a que el administrador agregue algunas.",
  miniapps_list_create_mini_app_button: "Crear mini app",
  miniapps_list_available_apps_title: "Apps disponibles ({count})",
  miniapps_list_no_description: "Sin descripción",
  miniapps_list_info_text:
    "Las mini apps son aplicaciones web ligeras que funcionan dentro de Linqx. Pueden acceder a tu perfil (con permiso) e integrarse con las funciones de la plataforma.",
  miniapps_details_loading: "Cargando detalles de la app...",
  miniapps_details_error_title: "No se pudo cargar la app",
  miniapps_details_by_developer: "por {developer}",
  miniapps_details_status_active: "Activa",
  miniapps_details_status_system: "Del sistema",
  miniapps_details_open_app_button: "Abrir app",
  miniapps_details_app_info_title: "Información de la app",
  miniapps_details_version_label: "Versión",
  miniapps_details_app_id_label: "ID de la app",
  miniapps_details_added_label: "Agregada",
  miniapps_details_system_app_label: "App del sistema",
  miniapps_details_system_app_description:
    "App integrada gestionada por Linqx. Los permisos se configuran automáticamente.",
  miniapps_details_permissions_title: "Permisos",
  miniapps_details_no_permissions: "Esta app no requiere permisos especiales.",
  miniapps_details_danger_zone_title: "Zona de peligro",
  miniapps_details_delete_app_button: "Eliminar app",
  miniapps_details_cannot_delete_title: "No se puede eliminar",
  miniapps_details_cannot_delete_message:
    "Las apps del sistema no se pueden eliminar.",
  miniapps_details_delete_confirm_title: "Eliminar mini app",
  miniapps_details_delete_confirm_message:
    '¿Seguro que quieres eliminar "{appName}"? Esta acción no se puede deshacer.',
  miniapps_details_error_load: "No se pudieron cargar los detalles de la app",
  miniapps_ok_button: "OK",
  miniapps_details_permission_update_error: "No se pudo actualizar el permiso",
  miniapps_details_delete_error: "No se pudo eliminar la mini app",
  miniapps_create_title: "Crear mini app",
  miniapps_create_subtitle: "Configura tu nueva mini app",
  miniapps_create_basic_info_title: "Información básica",
  miniapps_create_app_id_label: "ID de la app",
  miniapps_create_app_id_placeholder: "com.example.myapp",
  miniapps_create_app_id_error_required: "El ID de la app es obligatorio",
  miniapps_create_app_id_error_format:
    "El ID de la app debe empezar por una letra y contener solo minúsculas, números, puntos y guiones",
  miniapps_create_name_label: "Nombre",
  miniapps_create_name_placeholder: "Mi app increíble",
  miniapps_create_name_error_required: "El nombre es obligatorio",
  miniapps_create_description_label: "Descripción",
  miniapps_create_description_placeholder: "Describe lo que hace tu app...",
  miniapps_create_url_label: "URL",
  miniapps_create_url_placeholder: "https://example.com/app",
  miniapps_create_url_error_required: "La URL es obligatoria",
  miniapps_create_url_error_format:
    "La URL debe empezar por http://, https:// o data:",
  miniapps_create_icon_label: "Icono de la app",
  miniapps_create_icon_add: "Agregar",
  miniapps_create_icon_hint:
    "Toca para subir un icono cuadrado (recomendado 512x512)",
  miniapps_create_developer_label: "Desarrollador",
  miniapps_create_developer_placeholder: "Tu nombre o empresa",
  miniapps_create_version_label: "Versión",
  miniapps_create_version_placeholder: "1.0.0",
  miniapps_create_version_error_required: "La versión es obligatoria",
  miniapps_create_permissions_title: "Permisos",
  miniapps_create_permissions_description:
    "Selecciona qué permisos necesita tu app. Los permisos predeterminados se conceden automáticamente.",
  miniapps_create_enable_label: "Activar",
  miniapps_create_default_label: "Predeterminado",
  miniapps_create_cancel_button: "Cancelar",
  miniapps_create_creating: "Creando...",
  miniapps_create_submit_button: "Crear app",
  miniapps_create_success_title: "Listo",
  miniapps_create_success_message: "Mini app creada correctamente",
  miniapps_create_error: "No se pudo crear la mini app",
};
